import styled from "styled-components";

export const CardInformation = styled.div`
  margin: 10px 15px;
  width: 300px;
`;

export const Title = styled.h1`
  font-size: ${(props) => props.theme["@medium-font-size"]};
  font-weight: ${(props) => props.theme["@bold-font-weight"]};
  margin-bottom: 5px;
`;
export const Description = styled.h2`
  font-size: ${(props) => props.theme["@small-font-size"]};
  font-weight: ${(props) => props.theme["@normal-font-weight"]};
  margin-bottom: 15px;
`;
